import Branch from '@/assets/images/branch.svg'
import IconCard from '@/components/UI/IconCard'
import { useScreenOrientation, useScreenSize } from '@/hooks/screen'
import { FC, ReactNode } from 'react'

interface AuthCurrentLicenceCardProps {
    name: string
    id: string
    RightContent?: ReactNode
}

const AuthCurrentLicenceCard: FC<AuthCurrentLicenceCardProps> = ({ name, id, RightContent }) => {
    const screenSize = useScreenSize()
    const screenOrientation = useScreenOrientation()

    const marginTop = screenSize === 'small' && screenOrientation === 'landscape' ? 8 : 32

    return (
        <IconCard
            rounded
            title={name}
            subtitle={id}
            Icon={Branch}
            RightContent={RightContent}
            style={{ marginTop }}
        />
    )
}

export default AuthCurrentLicenceCard
